import { FC } from "react"


import './style.less'

interface ResultModalProps {
  amount: string
  mode: string
}

const ResultModal: FC<ResultModalProps> = ({ amount, mode }) => {
  return (
    <div className="result-modal">
      <div className="result-title">Payment {mode}</div>
      <div className="result-content">
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }}>
          <img
            className="result-content-image"
            src={mode === "successful" ? require("@/assets/paymentSuccess.png") : require("@/assets/paymentFailed.png")}
          />
          <div className="result-content-amount">{amount}</div>
        </div>
      </div>
      <div className="result-desc">
        <img src={require("@/assets/logo.png")} />
        <span>Powered by ReelPay</span>
      </div>
    </div>
  )
}

export default ResultModal
